import { useMutation } from "@tanstack/react-query";
import { useUserContext } from "../useUserContext";
import { addSupportUserReply } from "@/app/_firebase/support";
import { SupportTicket } from "@/app/@types/support";
import { sendSupportEmail } from "./useSendSupportEmail";

interface AddSupportReplyVariables {
  ticket: SupportTicket;
  body: string;
  files: File[];
}

const useAddSupportReply = () => {
  const user = useUserContext();

  return useMutation<void, Error, AddSupportReplyVariables>({
    mutationFn: ({ ticket, body, files }) =>
      addSupportUserReply({
        userId: user.uid,
        ticket,
        author: {
          uid: user.details?.uid ?? user.uid,
          fullName: user.details?.fullName ?? user.settings.name,
        },
        body,
        files,
      }),
    onSuccess: (_data, { ticket, body }) => {
      // Only email us on the first activity since we last looked; further
      // replies while the ticket is already unread just keep the badge lit.
      if (ticket.unreadForTeam) return;
      sendSupportEmail({
        kind: "user_reply",
        ticket,
        replyBody: body,
        replyAuthorName: user.details?.fullName ?? user.settings.name,
      });
    },
  });
};

export default useAddSupportReply;
